import React from "react"
import CabBox from "../CabCardBox"
import { useSelector } from "react-redux"

const fmtDate = (s) => {
  if (!s) return ""
  const d = new Date(s)
  if (isNaN(d.getTime())) return s
  return d.toLocaleDateString("en-IN", { weekday: "short", day: "2-digit", month: "short" })
}

const fmtTime = (t) => {
  if (!t) return ""
  if (/am|pm/i.test(t)) return t
  const [h, m] = t.split(":").map(Number)
  if (isNaN(h)) return t
  const ampm = h >= 12 ? "PM" : "AM"
  const h12 = h % 12 || 12
  return `${h12}:${String(m || 0).padStart(2, "0")} ${ampm}`
}

const Chip = ({ path, children }) => (
  <span className="pm-fares__chip">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {path}
    </svg>
    {children}
  </span>
)

const MainCab = ({ tripDetails }) => {
  const { cabs, distance } = useSelector((state) => state.cab)

  // trip_type: 3 = Outstation, 2 = Rental (hourly package), 1 = Local.
  const tripType = Number(tripDetails?.trip_type)
  const isOutstation = tripType === 3
  const isRental = tripType === 2
  const from = tripDetails?.pickup_city
  const to = tripDetails?.drop_city
  const roundTrip = tripDetails?.round_trip === 1 || tripDetails?.round_trip === "1"
  const pkgHours = Number(tripDetails?.package_type_in_hours) || 0
  const cabCount = cabs?.length || 0

  // Title reads correctly for each product (rental has no drop city; the API
  // returns package hours in the `distance` field, so never show it as km here).
  const title = isRental
    ? <>Your {from} rental cab, fixed price. <span>Right now.</span></>
    : isOutstation && to
      ? <>Your {from} to {to} cab, fixed price. <span>Right now.</span></>
      : <>Your {from} cab, fixed price. <span>Right now.</span></>

  return (
    <section className="pm-fares">
      <div className="pm-fares__head">
        <span className="pm-fares__eyebrow">Fixed price &middot; all inclusive</span>
        <h2 className="pm-fares__title">{title}</h2>

        <div className="pm-fares__summary">
          <Chip path={<><path d="M12 21s-7-6.6-7-11a7 7 0 0 1 14 0c0 4.4-7 11-7 11Z" /><circle cx="12" cy="10" r="2.5" /></>}>
            {from}{isOutstation && to ? <> &rarr; {to}</> : null}
          </Chip>
          {tripDetails?.trip_date && (
            <Chip path={<><rect x="3" y="4.5" width="18" height="16" rx="2.5" /><path d="M3 9h18M8 2.5v4M16 2.5v4" /></>}>
              {fmtDate(tripDetails.trip_date)}{tripDetails.trip_time ? `, ${fmtTime(tripDetails.trip_time)}` : ""}
            </Chip>
          )}

          {/* Trip-type specific chip: one-way/round for outstation, package for
              rental, "Local trip" for local. Never one-way for a rental. */}
          {isOutstation && (
            <Chip path={<><path d="M7 4v13M4 14l3 3 3-3M17 20V7M14 10l3-3 3 3" /></>}>
              {roundTrip ? "Round trip" : "One way"}
            </Chip>
          )}
          {isRental && pkgHours > 0 && (
            <Chip path={<><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>}>
              {pkgHours} hrs package
            </Chip>
          )}
          {!isOutstation && !isRental && (
            <Chip path={<><path d="M3 12h18M12 3v18" /></>}>Local trip</Chip>
          )}

          {/* Distance in km is only meaningful for outstation. */}
          {isOutstation && Math.ceil(distance) > 0 && (
            <Chip path={<><path d="M4 21 8 3M20 21 16 3M12 5v3M12 12v3M12 19v1" /></>}>
              {Math.ceil(distance)} km
            </Chip>
          )}
        </div>

        {cabCount > 0 && (
          <p className="pm-fares__count">
            {cabCount} {cabCount === 1 ? "option" : "options"} available &middot; driver allowance and GST already included
          </p>
        )}
      </div>

      <div className="pm-fares__grid">
        <CabBox tripDetails={tripDetails} />
      </div>
    </section>
  )
}

export default MainCab
